import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons'
import useLoadState from './useLoadState.js';
import * as generic from './generic.js';
import Clube from './Clube.js';

export default function JogoDetail(props) {
	const request = [ { url: "campeonato/" + props.campeonato + "/jogo", params: { fase: props.fase.id, rodada: props.rodada, clube: props.id_clube } } ];

	const [ state, setState, render ] = useLoadState(

		{ jogo: [] },

		[ props.id_clube, props.fase, props.rodada ],

		request,

		(result) => {
			let percMandante = null;
			let percVisitante = null;
			let stats = result[0].result[props.property];
			if (stats) {
				percMandante = stats.mandante?.perc;
				percVisitante = stats.visitante?.perc;
			}
			setState((state) => ({
				...state,
				jogo: result[0].result.list || [],
				percMandante: percMandante,
				percVisitante: percVisitante
			}))
		}
	);

	return render(() => {
		const listJogo = state.jogo.filter(e => parseFloat(e[props.property]) !== 0);
		const listJogoMandante = listJogo.filter(e => parseInt(e.is_mandante) > 0);
		const listJogoVisitante = listJogo.filter(e => parseInt(e.is_mandante) === 0);

		let title = "";
		let valorSimples = false;
		let format = (v) => v;

		switch (props.property) {
			case "pg": title="Pontos"; break;
			case "jg": title="Jogos"; break;
			case "vi": title="Vitórias"; break;
			case "em": title="Empates"; break;
			case "de": title="Derrotas"; break;
			case "gp": title="Gols Pró"; break;
			case "gc": title="Gols Contra"; break;
			case "pu": title="Público Pagante"; valorSimples = true; format = generic.fmtNumber; break;
			case "in": title="Ingresso à Venda"; valorSimples = true; format = generic.fmtNumber; break;
			case "rl": title="Renda Líquida"; valorSimples = true; format = generic.fmtCurrency; break;
			case "rb": title="Renda Bruta"; valorSimples = true; format = generic.fmtCurrency; break;
			default: return null;
		}
		return (
			<div className="row jogo-detail">
				<div className="button jogo-detail-close"><FontAwesomeIcon icon={fa.faTimesCircle}/></div>
				<div className="e10 title">{title}</div>
				{valorSimples ?
					<>
						<div className="e30 mandante">
							{listJogoMandante.map((item) => (
								<div>
									<span className={"placar " + (item[props.property] > item.placarv_tn ? "won" : (item[props.property] ? "lost" : ""))}>
										{format(item[props.property])}
									</span>
									<Clube clubeMap={props.clubeMap} clube={item.id_clubev}/>
								</div>
							))}
						</div>
						<div className="e30 visitante">
							{listJogoVisitante.map((item) => (
								<div>
									<Clube clubeMap={props.clubeMap} clube={item.id_clubem}/>
									<span className={"placar " + (item[props.property] > item.placarv_tn ? "won" : (item[props.property] ? "lost" : ""))}>
										{item[props.property]}
									</span>
								</div>
							))}
						</div>
					</>
				:
					<>
						<div className="e30 mandante">
							<div className="jogo-title">Casa {listJogoMandante.length}
								{(state.percMandante !== null) ? " | " + generic.fmtPercent(state.percMandante) + "%" : ""}</div>
							{listJogoMandante.map((item) => (
								<div>
									<span className={"placar " + (item.placarm_tn > item.placarv_tn ? "won" : (item.placarm_tn < item.placarv_tn ? "lost" : "tie"))}>
										{item.placarm_tn}&nbsp;x&nbsp;{item.placarv_tn}
									</span>
									<Clube clubeMap={props.clubeMap} clube={item.id_clubev}/>
								</div>
							))}
						</div>
						<div className="e30 visitante">
							<div className="jogo-title">Fora {listJogoVisitante.length}
								{(state.percVisitante !== null) ? " | " + generic.fmtPercent(state.percVisitante) + "%" : ""}</div>
							{listJogoVisitante.map((item) => (
								<div>
									<Clube clubeMap={props.clubeMap} clube={item.id_clubem}/>
									<span className={"placar " + (item.placarm_tn < item.placarv_tn ? "won" : (item.placarm_tn > item.placarv_tn ? "lost" : "tie"))}>
										{item.placarm_tn}&nbsp;x&nbsp;{item.placarv_tn}
									</span>
								</div>
							))}
						</div>
					</>
				}
				<div className="e10 filler"></div> </div>
	       );
	});
}
